export default { borderRadiusSmall: '4px', borderRadiusMedium: '8px' }
